import { Outlet } from "react-router-dom";

const LedgerBalance = () => <Outlet />;

export default LedgerBalance;
